module.exports = __webpack_public_path__ + "static/media/phone.e715e9ac.svg";